export { SourceHomebaseWarehouse } from "./Constant/Constant";
import HomebaseWarehouseCreate from "./HomebaseWarehouseCreate";
import HomebaseWarehouseEdit from "./HomebaseWarehouseEdit";
import HomebaseWarehouseList from "./HomebaseWarehouseList";

export default {
  create: HomebaseWarehouseCreate,
  edit: HomebaseWarehouseEdit,
  list: HomebaseWarehouseList,
};
